import { inject, Injectable } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {
  InspectionAssemblyItem,
  InspectionMeasureType,
} from 'src/app/api/elite/types/inspection-assembly-item';
import {
  QualityControlInspectionDataDetailsComponent,
  QualityControlInspectionDataDetailsTypes,
} from '../dialog/data-measurement/data-measurement.component';
import { QualityControlInspectionDataViewApiService } from '../api/data-view.service';
import { QualityControlAuthService } from '../../../common/quality-control/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class QualityControlMeasureItemService {
  protected readonly dialog = inject(MatDialog);
  protected readonly apiRouter = inject(
    QualityControlInspectionDataViewApiService
  );
  protected readonly authService = inject(QualityControlAuthService);

  constructor() {}

  getMeasure(itemName: string): Observable<undefined | InspectionAssemblyItem> {
    return this.apiRouter.getAssemblyItem(itemName);
  }

  addEditMeasure(
    item?: InspectionAssemblyItem,
    specificGroups?: number,
    options?: {
      itemName?: string;
      enableQuantityPerInspection?: boolean;
    }
  ): Observable<undefined | InspectionAssemblyItem> {
    return this.dialog
      .open(QualityControlInspectionDataDetailsComponent, {
        data: {
          item,
          specificGroups,
          isReadonly: !this.authService.editInspectionSheet(),
          showQuantityPerInspection: options.enableQuantityPerInspection,
          itemName: options.itemName,
        },
        minWidth: '80%',
      })
      .afterClosed()
      .pipe(
        switchMap(
          (
            res: /*QualityControlDataMeasurementTypes*/ QualityControlInspectionDataDetailsTypes['result']
          ) => {
            if (!res) {
              return of(undefined);
            }

            return item
              ? this.apiRouter.update(item.id, res)
              : this.apiRouter.add(res);
          }
        )
      );
  }
}
